import { createActionNamespace } from 'Modules/core/redux';

import { MessagingQueueTypes, ShowModalPayload, ShowNotificationPayload } from './types';


const messagingAction = createActionNamespace('messaging');

export const messagingActions = {
    showNotification: messagingAction<ShowNotificationPayload>('SHOW_NOTIFICATION'),
    showModal: messagingAction<ShowModalPayload>('SHOW_MODAL'),
    updateModalProps: messagingAction<{ id: number, props: any }>('UPDATE_MODAL_PROPS'),
    hideMessage: messagingAction<number>('HIDE_MESSAGE'),
    closeAll: messagingAction<void>('CLOSE_ALL_MODAL'),
    enqueue: messagingAction<MessagingQueueTypes>('ENQUEUE_MESSAGE'),
};
